import UserSelectProvider from '../../../../../../../components/CIMSSelect/common/UserSelect/UserSelectContext'
import { ResponseDisciplinesTableProvider } from './ResponseDisciplinesTableContext'
import ResponseDisciplinesTable from './components/ResponseDisciplinesTable'

const ResponseDisciplines: React.FC = () => (
  <ResponseDisciplinesTableProvider>
    <UserSelectProvider>
      <ResponseDisciplinesTable />
    </UserSelectProvider>
  </ResponseDisciplinesTableProvider>
)

export default ResponseDisciplines
